export default {
pab57f00: "M174.613 124C185.347 97.1844 182.1 67.2418 168.256 44.2452L23.3348 64.2955L162.215 35.3746C103.683 -37.5584 -10.2415 10.8172 0.740232 102.9L174.613 124Z",
}
